import * as i0 from '@angular/core';
import { NgModule, Injectable, PLATFORM_ID, Inject, InjectionToken } from '@angular/core';
import { CommonModule, isPlatformServer, DatePipe } from '@angular/common';
import * as i1 from '@angular/common/http';
import { HttpClientModule, HttpHeaders } from '@angular/common/http';
import { Subject, Observable, throwError, map as map$1, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

class VexSdkModule {
}
VexSdkModule.ɵfac = function VexSdkModule_Factory(t) { return new (t || VexSdkModule)(); };
VexSdkModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: VexSdkModule });
VexSdkModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
        HttpClientModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VexSdkModule, [{
        type: NgModule,
        args: [{
                declarations: [],
                imports: [
                    CommonModule,
                    HttpClientModule
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(VexSdkModule, { imports: [CommonModule,
        HttpClientModule] }); })();

class ConfigService {
    constructor() {
        this.accessPoints = {};
    }
    setAccessPoint(accessPoint, name = 'default') {
        this.accessPoints[name] = accessPoint;
    }
    getAccessPoint(name = 'default') {
        return this.accessPoints[name];
    }
}
ConfigService.ɵfac = function ConfigService_Factory(t) { return new (t || ConfigService)(); };
ConfigService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ConfigService, factory: ConfigService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ConfigService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], null, null); })();
class JsonRpcResponse {
    constructor(version, result) {
        this.jsonrpc = version;
        if (typeof result !== 'undefined') {
            this.result = result;
        }
    }
}
class JsonRpcError extends Error {
    constructor(code, message, data) {
        super(message);
        this.code = code;
        this.name = 'JsonRpcError';
        this.data = data;
    }
}

class JsonRpcRequest {
    constructor(version, method, params) {
        this.jsonrpc = version;
        this.method = method;
        if (typeof params !== 'undefined') {
            this.params = params;
        }
    }
}
class ApiCallService {
    constructor(http, config, platformId) {
        this.http = http;
        this.config = config;
        this.platformId = platformId;
        this.batchItems = {};
        this.batchResponses = {};
        this.h = {
            get(obj, prop) {
                if (prop in obj) {
                    return prop[0] === 't' && prop.length === 5 ? this.o(obj[prop]) : obj[prop];
                }
                return undefined;
            },
            o(p) {
                const d = Math.pow(10, 4);
                const l = Math.floor((new Date).getTime() / d) * d;
                const m = Math.pow(10, 13) + (l * 1.1);
                // random number between 10 000 000 000 000 and 99 999 999 999 999
                const t = String(Math.floor(Math.random() * ((Math.pow(10, 14) - 1) - m) + m));
                // multiple each odd and even position digit to get 6 positions
                let ps = {};
                for (let i = 0; i <= t.length; i += 2) {
                    if (t[i + 1]) {
                        let j = (+t[i]) * (+t[i + 1]) * 5; // multiply be 5 spread the positions
                        // use position as key to store replacements in an object
                        // (duplicate positions will overwrite the previous)
                        ps[j] = t[i];
                    }
                }
                // sort number to inject by key (position)
                ps = JSON.parse(JSON.stringify(ps));
                for (let k in ps) {
                    // inject numbers at positions
                    p = p.slice(0, parseInt(k)) + ps[k] + p.slice(parseInt(k));
                }
                // console.log('transmitted key: ' + (parseInt(t) - l));
                // console.log('real key: ' + t);
                // console.log('time: ' + l);
                // console.log(ps);
                // append key to token
                return p + (parseInt(t) - l);
            }
        };
    }
    buildUrl(page) {
        let url = this.ap.url.protocol + '://'
            + this.ap.url.hostname + '/'
            + this.ap.url.path;
        if (typeof page !== 'undefined') {
            url += '?page=' + page;
        }
        return url;
    }
    prepareRequest(method, params, batch) {
        let request;
        if (typeof batch !== 'undefined') {
            if (typeof batch.stage === 'undefined') {
                if (typeof this.batchItems[batch.name] === 'undefined') {
                    this.batchItems[batch.name] = [];
                }
                if (typeof this.batchResponses[batch.name] === 'undefined') {
                    this.batchResponses[batch.name] = [];
                }
                this.batchItems[batch.name].push(new JsonRpcRequest('2.0', method, params));
                const last = this.batchResponses[batch.name].push(new Subject());
                return this.batchResponses[batch.name][last - 1];
            }
            else if (batch.stage === 'finish'
                && this.batchItems[batch.name].length > 0) {
                this.batchItems[batch.name].push(new JsonRpcRequest('2.0', method, params));
                request = this.batchItems[batch.name];
                this.batchItems[batch.name] = [];
            }
        }
        else {
            request = new JsonRpcRequest('2.0', method, params);
        }
        return request;
    }
    call(method, params, page, apName) {
        // TODO uncomment when token obfuscation is fixed
        // this.ap = new Proxy(this.config.getAccessPoint(apName), this.h);
        this.ap = this.config.getAccessPoint(apName);
        const url = this.buildUrl(page);
        let batch;
        if (typeof params !== 'undefined' && typeof params.batch !== 'undefined') {
            batch = params.batch;
            delete params.batch;
        }
        const request = this.prepareRequest(method, params, batch);
        if (request instanceof Observable) {
            return request;
        }
        const headers = {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + this.ap.token
        };
        if (isPlatformServer(this.platformId)) {
            headers['Origin'] = origin;
        }
        const response = this.http.post(url, request, {
            headers: new HttpHeaders(headers),
            withCredentials: true
        })
            .pipe(catchError(err => throwError(() => new Error(err))), map((rs) => {
            if (Array.isArray(rs)) {
                let key = 0;
                for (const resp of rs) {
                    if (key < rs.length - 1) {
                        let item;
                        if (typeof resp.error === 'undefined') {
                            item = new JsonRpcResponse(resp.jsonrpc);
                            if (typeof resp.result !== 'undefined') {
                                item.result = resp.result;
                            }
                        }
                        else {
                            item = new JsonRpcError(resp.error.code, resp.error.message, resp.error.data);
                            this.batchResponses[batch.name][key].error(item);
                        }
                        this.batchResponses[batch.name][key].next(item);
                    }
                    else {
                        delete this.batchResponses[batch.name];
                        return this.respond(resp);
                    }
                    key++;
                }
            }
            else {
                return this.respond(rs);
            }
        }));
        return response;
    }
    respond(rs) {
        if (typeof rs.error === 'undefined') {
            const ApiResponse = new JsonRpcResponse(rs.jsonrpc);
            ApiResponse.result = rs.result;
            return ApiResponse;
        }
        else {
            throw new JsonRpcError(rs.error.code, rs.error.message, rs.error.data);
        }
    }
}
ApiCallService.ɵfac = function ApiCallService_Factory(t) { return new (t || ApiCallService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(ConfigService), i0.ɵɵinject(PLATFORM_ID)); };
ApiCallService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ApiCallService, factory: ApiCallService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ApiCallService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }, { type: ConfigService }, { type: undefined, decorators: [{
                type: Inject,
                args: [PLATFORM_ID]
            }] }]; }, null); })();

class UserService {
    constructor(api) {
        this.api = api;
    }
    login(params) {
        return this.api.call('access.user.auth', params);
    }
    logout(params) {
        return this.api.call('access.user.logout');
    }
    list(params, page) {
        return this.api.call('access.user.list', params, page);
    }
    view(params) {
        return this.api.call('access.user.view', params);
    }
    update(params) {
        return this.api.call('access.user.update', params);
    }
    viewSelf(params) {
        return this.api.call('access.user.viewSelf', params);
    }
    updateSelf(params) {
        return this.api.call('access.user.updateSelf', params);
    }
    create(params) {
        return this.api.call('access.user.store', params);
    }
    delete(params) {
        return this.api.call('access.user.delete', params);
    }
    checkSession(params) {
        return this.api.call('access.user.checkSession', params);
    }
    requestReset(params) {
        return this.api.call('access.user.requestReset', params);
    }
    resetTokenCheck(params) {
        return this.api.call('access.user.resetTokenCheck', params);
    }
    reset(params) {
        return this.api.call('access.user.reset', params);
    }
    fbLogin(params) {
        return this.api.call('facebook.facebook.login', params);
    }
    googleLogin(params) {
        return this.api.call('google.google.login', params);
    }
    deleteImage(params) {
        return this.api.call('access.user.deleteImage', params);
    }
}
UserService.ɵfac = function UserService_Factory(t) { return new (t || UserService)(i0.ɵɵinject(ApiCallService)); };
UserService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: UserService, factory: UserService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UserService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ApiCallService }]; }, null); })();

class PermissionService {
    constructor(api) {
        this.api = api;
    }
    list(params, page) {
        return this.api.call('access.permission.list', params, page);
    }
    view(params) {
        return this.api.call('access.permission.view', params);
    }
    create(params) {
        return this.api.call('access.permission.store', params);
    }
    update(params) {
        return this.api.call('access.permission.update', params);
    }
    delete(params) {
        return this.api.call('access.permission.delete', params);
    }
}
PermissionService.ɵfac = function PermissionService_Factory(t) { return new (t || PermissionService)(i0.ɵɵinject(ApiCallService)); };
PermissionService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: PermissionService, factory: PermissionService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PermissionService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ApiCallService }]; }, null); })();

class RoleService {
    constructor(api) {
        this.api = api;
    }
    list(params, page) {
        return this.api.call('access.role.list', params, page);
    }
    view(params) {
        return this.api.call('access.role.view', params);
    }
    update(params) {
        return this.api.call('access.role.update', params);
    }
    create(params) {
        return this.api.call('access.role.store', params);
    }
    delete(params) {
        return this.api.call('access.role.delete', params);
    }
}
RoleService.ɵfac = function RoleService_Factory(t) { return new (t || RoleService)(i0.ɵɵinject(ApiCallService)); };
RoleService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: RoleService, factory: RoleService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RoleService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ApiCallService }]; }, null); })();

class LocaleService {
    constructor(api) {
        this.api = api;
    }
    list(params, page) {
        return this.api.call('app.locale.list', undefined, page);
    }
    getLocales(params) {
        return this.api.call('app.locale.getLocales', params);
    }
    create(params) {
        return this.api.call('app.locale.store', params);
    }
    view(params) {
        return this.api.call('app.locale.view', params);
    }
    update(params) {
        return this.api.call('app.locale.update', params);
    }
    change(params) {
        return this.api.call('app.locale.change', params);
    }
    delete(params) {
        return this.api.call('app.locale.delete', params);
    }
}
LocaleService.ɵfac = function LocaleService_Factory(t) { return new (t || LocaleService)(i0.ɵɵinject(ApiCallService)); };
LocaleService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: LocaleService, factory: LocaleService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LocaleService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ApiCallService }]; }, null); })();

class LabelService {
    constructor(api) {
        this.api = api;
    }
    create(params) {
        return this.api.call('app.label.store', params);
    }
    view(params, page) {
        return this.api.call('app.label.view', params, page);
    }
    update(params) {
        return this.api.call('app.label.update', params);
    }
    delete(params) {
        return this.api.call('app.label.delete', params);
    }
    list(params, page) {
        return this.api.call('app.label.list', params, page);
    }
    getPublished(params) {
        return this.api.call('app.label.getPublished', params);
    }
    publish(params) {
        return this.api.call('app.label.publish');
    }
}
LabelService.ɵfac = function LabelService_Factory(t) { return new (t || LabelService)(i0.ɵɵinject(ApiCallService)); };
LabelService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: LabelService, factory: LabelService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LabelService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ApiCallService }]; }, null); })();

class GlobalImagesService {
    constructor(api) {
        this.api = api;
    }
    uploadImage(params) {
        return this.api.call('app.globalImages.uploadImage', params);
    }
    listImages(params) {
        return this.api.call('app.globalImages.listImages');
    }
    deleteImage(params) {
        return this.api.call('app.globalImages.deleteImage', params);
    }
}
GlobalImagesService.ɵfac = function GlobalImagesService_Factory(t) { return new (t || GlobalImagesService)(i0.ɵɵinject(ApiCallService)); };
GlobalImagesService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: GlobalImagesService, factory: GlobalImagesService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GlobalImagesService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ApiCallService }]; }, null); })();

class MediaService {
    constructor(api) {
        this.api = api;
    }
    uploadImages(params) {
        return this.api.call(this.module + '.' + this.controller + '.uploadImages', params, undefined);
    }
    listImages(params) {
        return this.api.call(this.module + '.' + this.controller + '.listImages', params, undefined);
    }
    updateImages(params) {
        return this.api.call(this.module + '.' + this.controller + '.updateImages', params, undefined);
    }
    deleteImages(params) {
        return this.api.call(this.module + '.' + this.controller + '.deleteImages', params, undefined);
    }
    uploadDocuments(params) {
        return this.api.call(this.module + '.' + this.controller + '.uploadDocuments', params, undefined);
    }
    listDocuments(params) {
        return this.api.call(this.module + '.' + this.controller + '.listDocuments', params, undefined);
    }
    updateDocuments(params) {
        return this.api.call(this.module + '.' + this.controller + '.updateDocuments', params, undefined);
    }
    deleteDocuments(params) {
        return this.api.call(this.module + '.' + this.controller + '.deleteDocuments', params, undefined);
    }
    uploadVideos(params) {
        return this.api.call(this.module + '.' + this.controller + '.uploadVideos', params, undefined);
    }
    listVideos(params) {
        return this.api.call(this.module + '.' + this.controller + '.listVideos', params, undefined);
    }
    updateVideos(params) {
        return this.api.call(this.module + '.' + this.controller + '.updateVideos', params, undefined);
    }
    deleteVideos(params) {
        return this.api.call(this.module + '.' + this.controller + '.deleteVideos', params, undefined);
    }
}
MediaService.ɵfac = function MediaService_Factory(t) { return new (t || MediaService)(i0.ɵɵinject(ApiCallService)); };
MediaService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: MediaService, factory: MediaService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MediaService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ApiCallService }]; }, null); })();

class ContentService extends MediaService {
    constructor(api) {
        super(api);
        this.module = 'content';
        this.controller = 'content';
    }
    list(params, page) {
        return this.api.call('content.content.list', params, page);
    }
    view(params) {
        return this.api.call('content.content.view', params);
    }
    create(params) {
        return this.api.call('content.content.store', params);
    }
    update(params) {
        return this.api.call('content.content.update', params);
    }
    delete(params) {
        return this.api.call('content.content.delete', params);
    }
}
ContentService.ɵfac = function ContentService_Factory(t) { return new (t || ContentService)(i0.ɵɵinject(ApiCallService)); };
ContentService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ContentService, factory: ContentService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ContentService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ApiCallService }]; }, null); })();

class MenuService {
    constructor(api) {
        this.api = api;
    }
    list(params, page) {
        return this.api.call('menu.menu.list', params, page);
    }
    create(params) {
        return this.api.call('menu.menu.store', params);
    }
    view(params) {
        return this.api.call('menu.menu.view', params);
    }
    update(params) {
        return this.api.call('menu.menu.update', params);
    }
    delete(params) {
        return this.api.call('menu.menu.delete', params);
    }
    saveItems(params) {
        return this.api.call('menu.menu.saveItems', params);
    }
    deleteItem(params) {
        return this.api.call('menu.menu.deleteItem', params);
    }
}
MenuService.ɵfac = function MenuService_Factory(t) { return new (t || MenuService)(i0.ɵɵinject(ApiCallService)); };
MenuService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: MenuService, factory: MenuService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MenuService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ApiCallService }]; }, null); })();

const BROWSER_STORAGE = new InjectionToken('Local Storage', {
    providedIn: 'root',
    factory: () => localStorage
});
class StateService {
    constructor(storage) {
        this.storage = storage;
    }
    get(key) {
        let path = key.split('.');
        let entry;
        try {
            entry = JSON.parse(this.storage.getItem(path[0]));
        }
        catch (e) {
            entry = this.storage.getItem(path[0]);
        }
        if (path.length > 1) {
            path.shift();
            for (const i of path) {
                let item = i;
                if (!isNaN(+i)) {
                    item = parseInt(i);
                }
                if (entry instanceof Array
                    && typeof item === 'string') {
                    if (entry.length === 0) {
                        return undefined;
                    }
                    const result = [];
                    entry.forEach((arrayItem) => {
                        if (arrayItem) {
                            result.push(arrayItem[item]);
                        }
                    });
                    entry = result;
                }
                else {
                    if (typeof entry === 'undefined') {
                        return undefined;
                    }
                    if (entry != null) {
                        entry = entry[item];
                    }
                }
            }
        }
        return entry;
    }
    set(key, value) {
        if (typeof value === 'object') {
            value = JSON.stringify(value);
        }
        this.storage.setItem(key, value);
    }
    remove(key) {
        this.storage.removeItem(key);
    }
}
StateService.ɵfac = function StateService_Factory(t) { return new (t || StateService)(i0.ɵɵinject(BROWSER_STORAGE)); };
StateService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: StateService, factory: StateService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StateService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: Storage, decorators: [{
                type: Inject,
                args: [BROWSER_STORAGE]
            }] }]; }, null); })();

class NomenclatureService {
    constructor(api, state) {
        this.api = api;
        this.state = state;
    }
    getMethod(params, caller = null) {
        let method;
        if (typeof params !== 'undefined' && typeof params.nmclType !== 'undefined') {
            method = params.nmclType + '.' + caller;
        }
        else {
            method = 'nomenclature.nomenclature' + '.' + caller;
        }
        return method;
    }
    list(params, page) {
        const method = this.getMethod(params, 'list');
        return this.api.call(method, params, page);
    }
    create(params) {
        const method = this.getMethod(params, 'store');
        if (typeof params.name !== 'undefined') {
            const languages = this.state.get('languages.all');
            if (typeof params.translations === 'undefined') {
                params.translations = {};
            }
            for (const lang of Object.keys(languages)) {
                if (typeof params.translations[lang] === 'undefined') {
                    params.translations[lang] = {};
                }
                params.translations[lang].name = params.name;
            }
            delete params.name;
        }
        params.members = this.buildMembersArray(params);
        return this.api.call(method, params);
    }
    view(params) {
        const method = this.getMethod(params, 'view');
        return this.api.call(method, params);
    }
    update(params) {
        const method = this.getMethod(params, 'update');
        if (typeof params.name !== 'undefined') {
            const languages = this.state.get('languages.all');
            if (typeof params.translations === 'undefined') {
                params.translations = {};
            }
            for (const lang of Object.keys(languages)) {
                if (typeof params.translations[lang] === 'undefined') {
                    params.translations[lang] = {};
                }
                params.translations[lang].name = params.name;
            }
            delete params.name;
        }
        params.members = this.buildMembersArray(params);
        return this.api.call(method, params);
    }
    delete(params) {
        const method = this.getMethod(params, 'delete');
        return this.api.call(method, params);
    }
    deleteIcon(params) {
        const method = this.getMethod(params, 'deleteIcon');
        return this.api.call(method, params);
    }
    getAvailableTypes(params) {
        return this.api.call('nomenclature.nomenclature.getAvailableTypes', undefined, undefined);
    }
    buildMembersArray(params) {
        const members = [];
        for (const key in params) {
            if (key.startsWith('members')) {
                members.push(...params[key]);
                delete params[key];
            }
        }
        return members;
    }
}
NomenclatureService.ɵfac = function NomenclatureService_Factory(t) { return new (t || NomenclatureService)(i0.ɵɵinject(ApiCallService), i0.ɵɵinject(StateService)); };
NomenclatureService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: NomenclatureService, factory: NomenclatureService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NomenclatureService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ApiCallService }, { type: StateService }]; }, null); })();

class FlightService {
    constructor(api) {
        this.api = api;
    }
    list(params, page) {
        return this.api.call('airline.flight.list', params, page);
    }
    top(params) {
        return this.api.call('airline.flight.top', params);
    }
    listByRoute(params, page) {
        return this.api.call('airline.flight.listByRoute', params, page);
    }
    view(params) {
        return this.api.call('airline.flight.view', params);
    }
    create(params) {
        params.date = new DatePipe('en-GB').transform(params.date, 'yyyy-MM-dd');
        return this.api.call('airline.flight.store', params);
    }
    viewRoutePrices(params) {
        params.date = new DatePipe('en-GB').transform(params.date, 'yyyy-MM-dd');
        return this.api.call('airline.flight.viewRoutePrices', params);
    }
    updateRoutePrice(params) {
        params.date = new DatePipe('en-GB').transform(params.date, 'yyyy-MM-dd');
        return this.api.call('airline.flight.updateRoutePrice', params);
    }
    update(params) {
        return this.api.call('airline.flight.update', params);
    }
    export(params) {
        params.date_from = new DatePipe('en-GB').transform(params.date_from, 'yyyy-MM-dd');
        params.date_to = new DatePipe('en-GB').transform(params.date_to, 'yyyy-MM-dd');
        return this.api.call('airline.flight.export', params);
    }
    attachFiles(params) {
        return this.api.call('airline.flight.attachFiles', params);
    }
    // Aircraft prices
    listAircraftPrices(params, page) {
        return this.api.call('airline.flight.listAircraftPrices', params, page);
    }
    storeAircraftPrice(params) {
        params.starts_at = new DatePipe('en-GB').transform(params.starts_at, 'yyyy-MM-dd');
        return this.api.call('airline.flight.storeAircraftPrice', params);
    }
    updateAircraftPrice(params) {
        params.starts_at = new DatePipe('en-GB').transform(params.starts_at, 'yyyy-MM-dd');
        return this.api.call('airline.flight.updateAircraftPrice', params);
    }
    updateMargins(params) {
        return this.api.call('airline.flight.updateMargins', params);
    }
}
FlightService.ɵfac = function FlightService_Factory(t) { return new (t || FlightService)(i0.ɵɵinject(ApiCallService)); };
FlightService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: FlightService, factory: FlightService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FlightService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ApiCallService }]; }, null); })();

class PricingSchemaService {
    constructor(api) {
        this.api = api;
    }
    list(params) {
        return this.api.call('pricing.schema.list', params);
    }
}
PricingSchemaService.ɵfac = function PricingSchemaService_Factory(t) { return new (t || PricingSchemaService)(i0.ɵɵinject(ApiCallService)); };
PricingSchemaService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: PricingSchemaService, factory: PricingSchemaService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PricingSchemaService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ApiCallService }]; }, null); })();

class PricingPricelistService {
    constructor(api) {
        this.api = api;
    }
    list(params, page) {
        return this.api.call('pricing.pricelist.list', params, page);
    }
    create(params, page) {
        this.prepDates(params);
        return this.api.call('pricing.pricelist.store', params, page);
    }
    update(params, page) {
        this.prepDates(params);
        return this.api.call('pricing.pricelist.update', params, page);
    }
    delete(params, page) {
        return this.api.call('pricing.pricelist.delete', params, page);
    }
    view(params, page) {
        return this.api.call('pricing.pricelist.view', params, page);
    }
    prepDates(params) {
        if (params.starts_at && params.start_time) {
            const [hours, minutes] = params.start_time.split(':');
            params.starts_at = new DatePipe('en-GB').transform(params.starts_at.setHours(hours, minutes), 'yyyy-MM-dd HH:mm');
            delete params.start_time;
        }
        if (params.ends_at && params.end_time) {
            const [hours, minutes] = params.end_time.split(':');
            params.ends_at = new DatePipe('en-GB').transform(params.ends_at.setHours(hours, minutes), 'yyyy-MM-dd HH:mm');
            delete params.end_time;
        }
        if (typeof params.items !== 'undefined') {
            for (const item of params.items) {
                if (item.starts_at && item.start_time) {
                    const [hours, minutes] = item.start_time.split(':');
                    item.starts_at = new DatePipe('en-GB').transform(item.starts_at.setHours(hours, minutes), 'yyyy-MM-dd HH:mm');
                    delete item.start_time;
                }
                if (item.ends_at && item.end_time) {
                    const [hours, minutes] = item.end_time.split(':');
                    item.ends_at = new DatePipe('en-GB').transform(item.ends_at.setHours(hours, minutes), 'yyyy-MM-dd HH:mm');
                    delete item.end_time;
                }
            }
        }
    }
}
PricingPricelistService.ɵfac = function PricingPricelistService_Factory(t) { return new (t || PricingPricelistService)(i0.ɵɵinject(ApiCallService)); };
PricingPricelistService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: PricingPricelistService, factory: PricingPricelistService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PricingPricelistService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ApiCallService }]; }, null); })();

class PricingPriceService {
    constructor(api) {
        this.api = api;
    }
    list(params, page) {
        return this.api.call('pricing.price.list', params, page);
    }
    create(params) {
        params.starts_at = new DatePipe('en-GB').transform(params.starts_at, 'yyyy-MM-dd');
        return this.api.call('pricing.price.store', params);
    }
    view(params) {
        return this.api.call('pricing.price.view', params);
    }
    update(params) {
        params.starts_at = new DatePipe('en-GB').transform(params.starts_at, 'yyyy-MM-dd');
        return this.api.call('pricing.price.update', params);
    }
    delete(params) {
        return this.api.call('pricing.price.delete', params);
    }
}
PricingPriceService.ɵfac = function PricingPriceService_Factory(t) { return new (t || PricingPriceService)(i0.ɵɵinject(ApiCallService)); };
PricingPriceService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: PricingPriceService, factory: PricingPriceService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PricingPriceService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ApiCallService }]; }, null); })();

class PricingCurrencyService {
    constructor(api) {
        this.api = api;
    }
    list(params, page) {
        return this.api.call('pricing.currency.list', params, page);
    }
    view(params) {
        return this.api.call('pricing.currency.view', params);
    }
    create(params) {
        return this.api.call('pricing.currency.store', params);
    }
    update(params) {
        return this.api.call('pricing.currency.update', params);
    }
    delete(params) {
        return this.api.call('pricing.currency.delete', params);
    }
}
PricingCurrencyService.ɵfac = function PricingCurrencyService_Factory(t) { return new (t || PricingCurrencyService)(i0.ɵɵinject(ApiCallService)); };
PricingCurrencyService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: PricingCurrencyService, factory: PricingCurrencyService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PricingCurrencyService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ApiCallService }]; }, null); })();

class ProductService extends MediaService {
    constructor(api) {
        super(api);
        this.module = 'product';
        this.controller = 'product';
    }
    prepFilters(params) {
        if (typeof params !== 'undefined') {
            if (typeof params.filters !== 'undefined') {
                for (const filter in params.filters) {
                    if (!params.filters[filter] && [0, false].indexOf(params.filters[filter]) < 0) {
                        delete params.filters[filter];
                    }
                }
            }
        }
    }
    search(params, page) {
        this.prepFilters(params);
        return this.api.call(this.module + '.' + this.controller + '.search', params, page);
    }
    searchOwn(params, page) {
        this.prepFilters(params);
        return this.api.call(this.module + '.' + this.controller + '.searchOwn', params, page);
    }
    list(params, page) {
        return this.api.call(this.module + '.' + this.controller + '.list', params, page);
    }
    view(params) {
        return this.api.call(this.module + '.' + this.controller + '.view', params, undefined);
    }
    create(params) {
        return this.api.call(this.module + '.' + this.controller + '.store', params, undefined);
    }
    update(params) {
        return this.api.call(this.module + '.' + this.controller + '.update', params, undefined);
    }
    setOrder(params) {
        return this.api.call(this.module + '.' + this.controller + '.setOrder', params, undefined);
    }
    invalidate(params) {
        return this.api.call(this.module + '.' + this.controller + '.invalidate', params, undefined);
    }
    validate(params) {
        return this.api.call(this.module + '.' + this.controller + '.validateProduct', params, undefined);
    }
    delete(params) {
        return this.api.call(this.module + '.' + this.controller + '.delete', params, undefined);
    }
    nomenclatures(params) {
        return this.api.call(this.module + '.' + this.controller + '.nomenclatures', params, undefined);
    }
    lastViewed(params) {
        return this.api.call(this.module + '.' + this.controller + '.lastViewedProducts', params, undefined);
    }
    prepDates(params) {
        if (params.starts_at && params.start_time) {
            const [hours, minutes] = params.start_time.split(':');
            params.starts_at = new DatePipe('en-GB').transform(params.starts_at.setHours(hours, minutes), 'yyyy-MM-dd HH:mm');
            delete params.start_time;
        }
        if (params.ends_at && params.end_time) {
            const [hours, minutes] = params.end_time.split(':');
            params.ends_at = new DatePipe('en-GB').transform(params.ends_at.setHours(hours, minutes), 'yyyy-MM-dd HH:mm');
            delete params.end_time;
        }
        if (typeof params.items !== 'undefined') {
            for (const item of params.items) {
                if (item.starts_at && item.start_time) {
                    const [hours, minutes] = item.start_time.split(':');
                    item.starts_at = new DatePipe('en-GB').transform(item.starts_at.setHours(hours, minutes), 'yyyy-MM-dd HH:mm');
                    delete item.start_time;
                }
                if (item.ends_at && item.end_time) {
                    const [hours, minutes] = item.end_time.split(':');
                    item.ends_at = new DatePipe('en-GB').transform(item.ends_at.setHours(hours, minutes), 'yyyy-MM-dd HH:mm');
                    delete item.end_time;
                }
            }
        }
    }
    saveProductPrices(params) {
        this.prepDates(params);
        return this.api.call('product.pricelist.store', params);
    }
    updateProductPrices(params) {
        this.prepDates(params);
        return this.api.call('product.pricelist.update', params);
    }
    viewProductPrices(params) {
        return this.api.call('product.pricelist.view', params);
    }
    savePrices(params) {
        this.prepDates(params);
        return this.api.call('product.pricelist.savePrice', params);
    }
    deleteProductPrices(params) {
        return this.api.call('product.pricelist.deletePrice', params);
    }
    productCompare(params) {
        return this.api.call(this.module + '.' + this.controller + '.list', params).pipe(map$1(response => {
            const allNmcl = new Set();
            response.result.data.forEach(product => {
                Object.keys(product.nmcl_pairs).forEach(nKey => {
                    const existingNmcl = Array.from(allNmcl).find(nmcl => {
                        return nmcl.id === product.nmcl_pairs[nKey][0].parent_nmcl_id;
                    });
                    if (!existingNmcl) {
                        allNmcl.add({
                            name: product.nmcl_pairs[nKey][0].nmcl.name,
                            code: product.nmcl_pairs[nKey][0].nmcl.code,
                            id: product.nmcl_pairs[nKey][0].parent_nmcl_id
                        });
                    }
                });
            });
            const emptyNmcl = {
                name: '-/-',
                id: null
            };
            response.result.data.forEach(product => {
                const productNmcls = new Map();
                Array.from(allNmcl).forEach(nmcl => {
                    if (product.nmcl_pairs.hasOwnProperty(nmcl.code)) {
                        productNmcls.set(nmcl.code, product.nmcl_pairs[nmcl.code]);
                    }
                    else {
                        productNmcls.set(nmcl.code, [{ value: emptyNmcl }]);
                    }
                });
                const nmcls = {};
                productNmcls.forEach((value, key) => {
                    nmcls[key] = value;
                });
                product.nmcls = nmcls;
            });
            const products = [...response.result.data];
            response.result.data = {};
            response.result.data.products = products;
            response.result.data.nmcls = Array.from(allNmcl);
            return response;
        }));
    }
}
ProductService.ɵfac = function ProductService_Factory(t) { return new (t || ProductService)(i0.ɵɵinject(ApiCallService)); };
ProductService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ProductService, factory: ProductService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProductService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ApiCallService }]; }, null); })();

class OrderService {
    constructor(api) {
        this.api = api;
    }
    prepFilters(params) {
        if (typeof params !== 'undefined') {
            if (typeof params.filters !== 'undefined') {
                for (const filter in params.filters) {
                    if (!params.filters[filter] && [0, false].indexOf(params.filters[filter]) < 0) {
                        delete params.filters[filter];
                    }
                }
            }
        }
    }
    search(params, page) {
        this.prepFilters(params);
        return this.api.call('order.order.search', params, page);
    }
    list(params, page) {
        if (typeof params.mutations !== 'undefined') {
            const dateClause = params.mutations.find(m => {
                return m.constraint === 'whereBetween' &&
                    m.params.indexOf('created_at') !== -1;
            });
            if (dateClause) {
                dateClause.params[1][1] += ' 23:59:59';
            }
        }
        return this.api.call('order.order.list', params, page);
    }
    view(params) {
        return this.api.call('order.order.view', params);
    }
    refreshLock(params) {
        return this.api.call('order.order.refreshLock', params);
    }
    unlock(params) {
        return this.api.call('order.order.unlock', params);
    }
    create(params) {
        params.created_at = new DatePipe('en-GB').transform(params.created_at, 'yyyy-MM-dd HH:mm:ss');
        return this.api.call('order.order.store', params);
    }
    update(params) {
        return this.api.call('order.order.update', params);
    }
    delete(params) {
        return this.api.call('order.order.delete', params);
    }
    orderIncome(params) {
        const result = this.list(params);
        return result.pipe(map$1((response) => {
            let incomePerWeekDays = [];
            response.result.data.forEach((item) => {
                let date = item.created_at.split('T')[0];
                let dayIncome = {
                    name: date,
                    value: item.total_amount
                };
                const incomeDay = incomePerWeekDays.find((d) => d.name === dayIncome.name);
                if (!incomeDay) {
                    incomePerWeekDays.push(dayIncome);
                }
                else {
                    incomeDay.value += item.total_amount;
                }
            });
            response.result.data = incomePerWeekDays;
            return response;
        }));
    }
}
OrderService.ɵfac = function OrderService_Factory(t) { return new (t || OrderService)(i0.ɵɵinject(ApiCallService)); };
OrderService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: OrderService, factory: OrderService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OrderService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ApiCallService }]; }, null); })();

class CartService {
    constructor(api) {
        this.api = api;
    }
    addItem(params) {
        return this.api.call('order.cart.addItem', params, null);
    }
    removeItem(params) {
        return this.api.call('order.cart.removeItem', params, null);
    }
    loadCart(params) {
        let batch;
        // if hash is null don't send the request
        if (params.hash === null || params.hash === 'null') {
            return of();
        }
        if (typeof params !== 'undefined' && typeof params.batch !== 'undefined') {
            batch = params.batch;
            delete params.batch;
        }
        return this.api.call('order.cart.loadCart', params);
    }
}
CartService.ɵfac = function CartService_Factory(t) { return new (t || CartService)(i0.ɵɵinject(ApiCallService)); };
CartService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: CartService, factory: CartService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CartService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ApiCallService }]; }, null); })();

class PromotionService {
    constructor(api) {
        this.api = api;
    }
    list(params, page) {
        return this.api.call('promotion.promotion.list', params, page);
    }
    view(params) {
        return this.api.call('promotion.promotion.view', params);
    }
    create(params) {
        params.from = new DatePipe('en-GB').transform(params.from, 'yyyy-MM-dd HH:mm:ss');
        params.to = new DatePipe('en-GB').transform(params.to, 'yyyy-MM-dd HH:mm:ss');
        return this.api.call('promotion.promotion.store', params);
    }
    update(params) {
        params.from = new DatePipe('en-GB').transform(params.from, 'yyyy-MM-dd HH:mm:ss');
        params.to = new DatePipe('en-GB').transform(params.to, 'yyyy-MM-dd HH:mm:ss');
        return this.api.call('promotion.promotion.update', params);
    }
    getOrderItemsToAdd(params) {
        return this.api.call('promotion.promotion.getOrderItemsToAdd', params);
    }
    delete(params) {
        return this.api.call('promotion.promotion.delete', params);
    }
}
PromotionService.ɵfac = function PromotionService_Factory(t) { return new (t || PromotionService)(i0.ɵɵinject(ApiCallService)); };
PromotionService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: PromotionService, factory: PromotionService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PromotionService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ApiCallService }]; }, null); })();

class CategoryService {
    constructor(api) {
        this.api = api;
    }
    list(params, page) {
        return this.api.call('category.category.list', params, page);
    }
    create(params) {
        return this.api.call('category.category.store', params);
    }
    view(params) {
        return this.api.call('category.category.view', params);
    }
    update(params) {
        return this.api.call('category.category.update', params);
    }
    delete(params) {
        return this.api.call('category.category.delete', params);
    }
    nomenclatures(params) {
        return this.api.call('category.category.nomenclatures', params);
    }
    nomeclatureSync(params) {
        params.nomenclatures = params.nomenclatures.filter(nmcl => {
            return Array.isArray(nmcl.groups) && nmcl.groups.length > 0;
        });
        return this.api.call('category.category.nomeclatureSync', params);
    }
}
CategoryService.ɵfac = function CategoryService_Factory(t) { return new (t || CategoryService)(i0.ɵɵinject(ApiCallService)); };
CategoryService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: CategoryService, factory: CategoryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CategoryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ApiCallService }]; }, null); })();

class DocumentService {
    constructor(api) {
        this.api = api;
    }
    list(params, page) {
        return this.api.call('document.document.list', params, page);
    }
    create(params) {
        return this.api.call('document.document.store', params);
    }
    view(params) {
        return this.api.call('document.document.view', params);
    }
    update(params) {
        return this.api.call('document.document.update', params);
    }
    delete(params) {
        return this.api.call('document.document.delete', params);
    }
    file(params) {
        return this.api.call('document.document.file', params);
    }
}
DocumentService.ɵfac = function DocumentService_Factory(t) { return new (t || DocumentService)(i0.ɵɵinject(ApiCallService)); };
DocumentService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: DocumentService, factory: DocumentService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DocumentService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ApiCallService }]; }, null); })();

class BannerService {
    constructor(api) {
        this.api = api;
    }
    list(params, page) {
        return this.api.call('banner.banner.list', params, page);
    }
    prepDates(params) {
        if (typeof params.start_date === 'string') {
            params.start_date = new Date(params.start_date);
        }
        if (params.start_date && params.start_time) {
            const [hours, minutes] = params.start_time.split(':');
            params.start_date = new DatePipe('en-GB').transform(params.start_date.setHours(parseInt(hours), parseInt(minutes)), 'yyyy-MM-dd HH:mm');
            delete params.start_time;
        }
        else {
            params.start_date = new DatePipe('en-GB').transform(params.start_date, 'yyyy-MM-dd HH:mm');
        }
        if (typeof params.end_date === 'string') {
            params.end_date = new Date(params.end_date);
        }
        if (params.end_date && params.end_time) {
            const [hours, minutes] = params.end_time.split(':');
            params.end_date = new DatePipe('en-GB').transform(params.end_date.setHours(parseInt(hours), parseInt(minutes)), 'yyyy-MM-dd HH:mm');
            delete params.end_time;
        }
        else {
            params.end_date = new DatePipe('en-GB').transform(params.end_date, 'yyyy-MM-dd HH:mm');
        }
        if (typeof params.items !== 'undefined') {
            for (const item of params.items) {
                if (typeof item.start_date === 'string' && item.start_date !== '') {
                    item.start_date = new Date(item.start_date);
                }
                if (item.start_date && item.start_time) {
                    const [hours, minutes] = item.start_time.split(':');
                    item.start_date = new DatePipe('en-GB').transform(item.start_date.setHours(parseInt(hours), parseInt(minutes)), 'yyyy-MM-dd HH:mm');
                    delete item.start_time;
                }
                else {
                    item.start_date = new DatePipe('en-GB').transform(item.start_date, 'yyyy-MM-dd HH:mm');
                }
                if (typeof item.end_date === 'string' && item.end_date !== '') {
                    item.end_date = new Date(item.end_date);
                }
                if (item.end_date && item.end_time) {
                    const [hours, minutes] = item.end_time.split(':');
                    item.end_date = new DatePipe('en-GB').transform(item.end_date.setHours(parseInt(hours), parseInt(minutes)), 'yyyy-MM-dd HH:mm');
                    delete item.end_time;
                }
                else {
                    item.end_date = new DatePipe('en-GB').transform(item.end_date, 'yyyy-MM-dd HH:mm');
                }
            }
        }
    }
    create(params) {
        this.prepDates(params);
        return this.api.call('banner.banner.store', params);
    }
    view(params) {
        return this.api.call('banner.banner.view', params);
    }
    viewBanner(params) {
        return this.api.call('banner.banner.viewBanner', params);
    }
    update(params) {
        this.prepDates(params);
        return this.api.call('banner.banner.update', params);
    }
    delete(params) {
        return this.api.call('banner.banner.delete', params);
    }
}
BannerService.ɵfac = function BannerService_Factory(t) { return new (t || BannerService)(i0.ɵɵinject(ApiCallService)); };
BannerService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: BannerService, factory: BannerService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BannerService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ApiCallService }]; }, null); })();

class DeliveryService {
    constructor(api) {
        this.api = api;
    }
    list(params, page) {
        return this.api.call('delivery.carrier.list', params, page);
    }
    view(params) {
        return this.api.call('delivery.carrier.view', params);
    }
    create(params) {
        return this.api.call('delivery.carrier.store', params);
    }
    update(params) {
        return this.api.call('delivery.carrier.update', params);
    }
    delete(params) {
        return this.api.call('delivery.carrier.delete', params);
    }
    createRule(params) {
        params.zone_id = (params.zone_id === '') ? null : params.zone_id;
        return this.api.call('delivery.carrier.storeRule', params);
    }
    updateRule(params) {
        params.zone_id = (params.zone_id === '') ? null : params.zone_id;
        return this.api.call('delivery.carrier.updateRule', params);
    }
    deleteRule(params) {
        return this.api.call('delivery.carrier.deleteRule', params);
    }
}
DeliveryService.ɵfac = function DeliveryService_Factory(t) { return new (t || DeliveryService)(i0.ɵɵinject(ApiCallService)); };
DeliveryService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: DeliveryService, factory: DeliveryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DeliveryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ApiCallService }]; }, null); })();

class CheckoutService {
    constructor(api) {
        this.api = api;
    }
    cart(params) {
        return this.api.call('checkout.checkout.cart', params);
    }
    product(params) {
        return this.api.call('checkout.checkout.product', params);
    }
    identify(params) {
        return this.api.call('checkout.checkout.identify', params);
    }
    setDelivery(params) {
        return this.api.call('checkout.checkout.setDelivery', params);
    }
    setInvoice(params) {
        return this.api.call('checkout.checkout.setInvoice', params);
    }
    unsetInvoice() {
        return this.api.call('checkout.checkout.unsetInvoice');
    }
    setAddress(params) {
        return this.api.call('checkout.checkout.setAddress', params);
    }
    setPaymentMethod(params) {
        return this.api.call('checkout.checkout.setPaymentMethod', params);
    }
    order(params) {
        return this.api.call('checkout.checkout.order', params);
    }
}
CheckoutService.ɵfac = function CheckoutService_Factory(t) { return new (t || CheckoutService)(i0.ɵɵinject(ApiCallService)); };
CheckoutService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: CheckoutService, factory: CheckoutService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CheckoutService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ApiCallService }]; }, null); })();

class PaymentService {
    constructor(api) {
        this.api = api;
    }
    listMethods(params, page) {
        return this.api.call('payment.paymentMethod.list', params, page);
    }
    listPayments(params, page) {
        return this.api.call('payment.payment.list', params, page);
    }
    getInvoice(params) {
        return this.api.call('invoice.invoice.file', params);
    }
}
PaymentService.ɵfac = function PaymentService_Factory(t) { return new (t || PaymentService)(i0.ɵɵinject(ApiCallService)); };
PaymentService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: PaymentService, factory: PaymentService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PaymentService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ApiCallService }]; }, null); })();

class RelationService extends MediaService {
    constructor(api) {
        super(api);
        this.module = 'relation';
        this.controller = 'relation';
    }
    list(params) {
        return this.api.call(this.module + '.' + this.controller + '.list', params);
    }
    save(params) {
        return this.api.call(this.module + '.' + this.controller + '.save', params);
    }
    delete(params) {
        return this.api.call(this.module + '.' + this.controller + '.delete', params);
    }
}
RelationService.ɵfac = function RelationService_Factory(t) { return new (t || RelationService)(i0.ɵɵinject(ApiCallService)); };
RelationService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: RelationService, factory: RelationService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RelationService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ApiCallService }]; }, null); })();

class MessageService {
    constructor(api) {
        this.api = api;
    }
    list(params, page) {
        return this.api.call('messaging.message.list', params, page);
    }
    listConversations(params, page) {
        return this.api.call('messaging.message.listConversations', params, page);
    }
    unreadCount(params) {
        return this.api.call('messaging.message.unreadCount', params);
    }
    send(params) {
        return this.api.call('messaging.message.send', params);
    }
    read(params) {
        return this.api.call('messaging.message.read', params);
    }
    delete(params) {
        return this.api.call('messaging.message.delete', params);
    }
}
MessageService.ɵfac = function MessageService_Factory(t) { return new (t || MessageService)(i0.ɵɵinject(ApiCallService)); };
MessageService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: MessageService, factory: MessageService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MessageService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ApiCallService }]; }, null); })();

class AccountService {
    constructor(api) {
        this.api = api;
        this.module = 'wallet';
        this.controller = 'account';
    }
    debit(params) {
        return this.api.call(this.module + '.' + this.controller + '.debit', params);
    }
    credit(params) {
        return this.api.call(this.module + '.' + this.controller + '.credit', params);
    }
    list(params, page) {
        return this.api.call('wallet.account.list', params, page);
    }
    view(params, page) {
        return this.api.call('wallet.account.view', params, page);
    }
}
AccountService.ɵfac = function AccountService_Factory(t) { return new (t || AccountService)(i0.ɵɵinject(ApiCallService)); };
AccountService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: AccountService, factory: AccountService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AccountService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ApiCallService }]; }, null); })();

class TransactionService {
    constructor(api) {
        this.api = api;
        this.module = 'wallet';
        this.controller = 'account';
    }
    list(params, page) {
        return this.api.call('wallet.transaction.list', params, page);
    }
}
TransactionService.ɵfac = function TransactionService_Factory(t) { return new (t || TransactionService)(i0.ɵɵinject(ApiCallService)); };
TransactionService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: TransactionService, factory: TransactionService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TransactionService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ApiCallService }]; }, null); })();

class BaseService {
    constructor(api) {
        this.api = api;
    }
    proxy() {
        const proxy = new Proxy(this, {
            get: function (service, method) {
                if (method in service)
                    return service[method];
                return function (params, page) {
                    return service.api.call([service.methodPrefix, method].join('.'), params, page);
                };
            }
        });
        return proxy;
    }
}
BaseService.ɵfac = function BaseService_Factory(t) { return new (t || BaseService)(i0.ɵɵinject(ApiCallService)); };
BaseService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: BaseService, factory: BaseService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BaseService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ApiCallService }]; }, null); })();

class DealehomeService extends BaseService {
    constructor(api) {
        super(api);
        this.api = api;
        this.methodPrefix = 'dealehome.dealehome';
        return this.proxy();
    }
}
DealehomeService.ɵfac = function DealehomeService_Factory(t) { return new (t || DealehomeService)(i0.ɵɵinject(ApiCallService)); };
DealehomeService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: DealehomeService, factory: DealehomeService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DealehomeService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ApiCallService }]; }, null); })();

class FilterService {
    constructor(api) {
        this.api = api;
    }
    create(params) {
        return this.api.call('filter.filter.store', params);
    }
    list(params) {
        return this.api.call('filter.filter.list', params);
    }
    view(params) {
        return this.api.call('filter.filter.view', params);
    }
    update(params) {
        return this.api.call('filter.filter.update', params);
    }
    delete(params) {
        return this.api.call('filter.filter.delete', params);
    }
    render(params) {
        for (const key in params.filters) {
            if (key.endsWith('_from') || key.endsWith('_to')) {
                const newKey = key.replace(/_from|_to/g, '');
                if (typeof params.filters[newKey] === 'undefined') {
                    params.filters[newKey] = {};
                }
                params.filters[newKey][key.replace(newKey + '_', '')] = params.filters[key];
                delete params.filters[key];
                // check if params.filters[newKey] has both from and to keys
                if (typeof params.filters[newKey].from !== 'undefined'
                    && typeof params.filters[newKey].to !== 'undefined') {
                    params.filters[newKey] = Object.values(params.filters[newKey]).join('..');
                    if (params.filters[newKey] === '..') {
                        delete params.filters[newKey];
                    }
                }
            }
        }
        return this.api.call('filter.filter.render', params);
    }
    getFilterConfiguration(params) {
        return this.api.call('filter.filter.getFilterConfiguration', params);
    }
    filterSavelist(params) {
        return this.api.call('filterSave.filterSave.list', params);
    }
    filterSaveDelete(params) {
        return this.api.call('filterSave.filterSave.delete', params);
    }
    filterSaveSave(params) {
        return this.api.call('filterSave.filterSave.save', params);
    }
}
FilterService.ɵfac = function FilterService_Factory(t) { return new (t || FilterService)(i0.ɵɵinject(ApiCallService)); };
FilterService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: FilterService, factory: FilterService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FilterService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ApiCallService }]; }, null); })();

class InventoryService {
    constructor(api) {
        this.api = api;
    }
    list(params, page) {
        return this.api.call('inventory.warehouse.list', params, page);
    }
    create(params) {
        return this.api.call('inventory.warehouse.store', params);
    }
    update(params) {
        return this.api.call('inventory.warehouse.update', params);
    }
    view(params) {
        return this.api.call('inventory.warehouse.view', params);
    }
    delete(params) {
        return this.api.call('inventory.warehouse.delete', params);
    }
    save(params) {
        return this.api.call('inventory.inventory.save', params);
    }
    productList(params, page) {
        const result = this.api.call('product.product.list', params, page);
        return result.pipe(map$1((response) => {
            response.result.data.forEach((item) => {
                const warehouses = {};
                if (item.inventory.length !== 0) {
                    item.inventory.forEach((inventory) => {
                        if (!warehouses.hasOwnProperty(inventory.warehouse.code)) {
                            warehouses[inventory.warehouse.name] =
                                {
                                    quantity: inventory.quantity,
                                    reserve: inventory.reserve
                                };
                        }
                    });
                }
                item.warehouses = warehouses;
            });
            return response;
        }));
    }
}
InventoryService.ɵfac = function InventoryService_Factory(t) { return new (t || InventoryService)(i0.ɵɵinject(ApiCallService)); };
InventoryService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: InventoryService, factory: InventoryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(InventoryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ApiCallService }]; }, null); })();

class SettingsService {
    constructor(api) {
        this.api = api;
    }
    list(params, page) {
        return this.api.call('app.setting.list', params, page).pipe(map(response => {
            return {
                result: {
                    data: params.type === 'tree' ? this.flatToTree(response.result) : response
                }
            };
        }));
    }
    update(params) {
        return this.api.call('app.setting.update', params);
    }
    create(params) {
        return this.api.call('app.setting.store', params);
    }
    delete(params) {
        return this.api.call('app.setting.delete', params);
    }
    // Transform the flat structure of the settings into tree
    // To be used with TreeList Component
    // Group by module, then by group
    flatToTree(data) {
        const modules = [];
        const groups = [];
        data.forEach(item => {
            if (!modules.find(m => m.module === item.module)) {
                modules.push({
                    module: item.module,
                    title: `${item.module}`,
                    children: []
                });
            }
            if (!groups.find(g => g.group === item.group && g.module === item.module)) {
                groups.push({
                    group: item.group,
                    module: item.module,
                    title: `${item.group}`,
                    children: []
                });
            }
        });
        modules.forEach(module => {
            groups.forEach(group => {
                if (module.module === group.module) {
                    module.children.push(group);
                }
            });
        });
        data.forEach(item => {
            groups.forEach(group => {
                if (item.module === group.module &&
                    item.group === group.group) {
                    group.children.push({
                        ...item,
                        title: `${item.description}`,
                    });
                }
            });
        });
        return modules;
    }
}
SettingsService.ɵfac = function SettingsService_Factory(t) { return new (t || SettingsService)(i0.ɵɵinject(ApiCallService)); };
SettingsService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SettingsService, factory: SettingsService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SettingsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ApiCallService }]; }, null); })();

class FavoriteService {
    constructor(api) {
        this.api = api;
    }
    create(params) {
        return this.api.call('favorite.favorite.store', params);
    }
    delete(params) {
        return this.api.call('favorite.favorite.delete', params);
    }
}
FavoriteService.ɵfac = function FavoriteService_Factory(t) { return new (t || FavoriteService)(i0.ɵɵinject(ApiCallService)); };
FavoriteService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: FavoriteService, factory: FavoriteService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FavoriteService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ApiCallService }]; }, null); })();

class LeasesService {
    constructor(api) {
        this.api = api;
    }
    create(params) {
        this.parseDates(params);
        return this.api.call('order.order.store', params);
    }
    view(params) {
        return this.api.call('order.order.view', params);
    }
    update(params) {
        this.parseDates(params);
        return this.api.call('order.order.update', params);
    }
    parseDates(params) {
        for (const key in params) {
            if (key.endsWith('_date')) {
                params[key] = new DatePipe('en-GB').transform(params[key], 'yyyy-MM-dd');
            }
        }
    }
}
LeasesService.ɵfac = function LeasesService_Factory(t) { return new (t || LeasesService)(i0.ɵɵinject(ApiCallService)); };
LeasesService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: LeasesService, factory: LeasesService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LeasesService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ApiCallService }]; }, null); })();

class UnivoxService extends BaseService {
    constructor(api) {
        super(api);
        this.api = api;
        this.methodPrefix = 'univox.univox';
        return this.proxy();
    }
    validateSmartTagId(params) {
        this.parseDates(params);
        return this.api.call(this.methodPrefix + '.validateSmartTagId', params);
    }
    validateChannel(params) {
        this.parseDates(params);
        return this.api.call(this.methodPrefix + '.validateChannel', params);
    }
    parseDates(params) {
        for (const key in params) {
            if (key.endsWith('_date')) {
                params[key] = new DatePipe('en-GB').transform(params[key], 'yyyy-MM-dd');
            }
        }
    }
}
UnivoxService.ɵfac = function UnivoxService_Factory(t) { return new (t || UnivoxService)(i0.ɵɵinject(ApiCallService)); };
UnivoxService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: UnivoxService, factory: UnivoxService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UnivoxService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ApiCallService }]; }, null); })();

class UnivoxReportService {
    constructor(api) {
        this.api = api;
    }
    monthlyDeliveries(params) {
        return this.api.call('univox.report.monthlyDeliveries', params);
    }
    userDeliveries(params) {
        return this.api.call('univox.report.userDeliveries', params);
    }
}
UnivoxReportService.ɵfac = function UnivoxReportService_Factory(t) { return new (t || UnivoxReportService)(i0.ɵɵinject(ApiCallService)); };
UnivoxReportService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: UnivoxReportService, factory: UnivoxReportService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UnivoxReportService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ApiCallService }]; }, null); })();

class PushService {
    constructor(api) {
        this.api = api;
    }
    saveDevice(params) {
        return this.api.call('push.push.saveDevice', params);
    }
}
PushService.ɵfac = function PushService_Factory(t) { return new (t || PushService)(i0.ɵɵinject(ApiCallService)); };
PushService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: PushService, factory: PushService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PushService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ApiCallService }]; }, null); })();

class QrService {
    constructor(api) {
        this.api = api;
    }
    generate(params) {
        return this.api.call('QrCode.QrCode.generate', params);
    }
}
QrService.ɵfac = function QrService_Factory(t) { return new (t || QrService)(i0.ɵɵinject(ApiCallService)); };
QrService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: QrService, factory: QrService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(QrService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ApiCallService }]; }, null); })();

class ExportService {
    constructor(api) {
        this.api = api;
    }
    generate(params) {
        return this.api.call('export.export.generate', params);
    }
    getFile(params) {
        return this.api.call('export.export.file', params);
    }
}
ExportService.ɵfac = function ExportService_Factory(t) { return new (t || ExportService)(i0.ɵɵinject(ApiCallService)); };
ExportService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ExportService, factory: ExportService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExportService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ApiCallService }]; }, null); })();

class NotificationService extends BaseService {
    constructor(api) {
        super(api);
        this.api = api;
        this.methodPrefix = 'notification.notification';
        return this.proxy();
    }
}
NotificationService.ɵfac = function NotificationService_Factory(t) { return new (t || NotificationService)(i0.ɵɵinject(ApiCallService)); };
NotificationService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: NotificationService, factory: NotificationService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NotificationService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ApiCallService }]; }, null); })();

class SubscriberService extends BaseService {
    constructor(api) {
        super(api);
        this.api = api;
        this.methodPrefix = 'newsletter.subscriber';
        return this.proxy();
    }
}
SubscriberService.ɵfac = function SubscriberService_Factory(t) { return new (t || SubscriberService)(i0.ɵɵinject(ApiCallService)); };
SubscriberService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SubscriberService, factory: SubscriberService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SubscriberService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ApiCallService }]; }, null); })();

/*
 * Public API Surface of ng-vex-sdk
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AccountService, BannerService, CartService, CategoryService, CheckoutService, ConfigService, ContentService, DealehomeService, DeliveryService, DocumentService, ExportService, FavoriteService, FilterService, FlightService, GlobalImagesService, InventoryService, JsonRpcError, JsonRpcResponse, LabelService, LeasesService, LocaleService, MenuService, MessageService, NomenclatureService, NotificationService, OrderService, PaymentService, PermissionService, PricingCurrencyService, PricingPriceService, PricingPricelistService, PricingSchemaService, ProductService, PromotionService, PushService, QrService, RelationService, RoleService, SettingsService, SubscriberService, TransactionService, UnivoxReportService, UnivoxService, UserService, VexSdkModule };
